import { render, staticRenderFns } from "./new_alert_modal.vue?vue&type=template&id=3d52dcf4&scoped=true&"
import script from "./new_alert_modal.vue?vue&type=script&lang=js&"
export * from "./new_alert_modal.vue?vue&type=script&lang=js&"
import style0 from "./new_alert_modal.vue?vue&type=style&index=0&id=3d52dcf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d52dcf4",
  null
  
)

export default component.exports